// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"63e2d5a6","286":"e9c859a2","315":"5650d338","522":"f9d570f9","639":"5529158e","773":"90bcd38d","831":"f6299908"}[chunkId] + ".chunk.css";
};